<template>
  <div>
      <a-drawer
        title="用户管理"
        :width="drawerWidth"
        @close="onClose"
        :visible="visible"
        >
    <div
      style="display:flex;flex-direction: row;margin-bottom:20px;justify-content: space-between;"
    >
      <a-button
        type="primary"
        @click="()=>{userCUModalVisible = true;updateUserModel = null;drivasstId=orgId}"
        icon="user-add"
      >新增用户</a-button>

      <div style="display:flex;flex-direction: row;justify-content: flex-end">
        <a-input style="width:20vw;" addonBefore="用户账号" placeholder="请输入用户账号" v-model="userCode"/>
        <a-input
          style="width:20vw;margin-left:16px;"
          addonBefore="用户姓名"
          placeholder="请输入用户姓名"
          v-model="userName"
        />
        <a-button type="primary" style="margin-left:16px;" icon="search" @click="fetch">查询</a-button>
      </div>
    </div>

    <j-table
      :tableColumns="columns"
      :rowKey="record => record.user_id"
      :tableData="data"
      :loading="loading"
      :tablePagination="pagination"
      v-on:onOrderbyChange="(newOrderby)=>{ orderby = newOrderby;fetch(); }"
      v-on:onPaginationChange="(newPagination)=>{ pagination = newPagination;fetch(); }"
    >
      <template v-slot="record">
        <div style="display:flex;flex-direction: row;justify-content:center;">
          <a-tooltip placement="top">
            <template slot="title">
              <span>编辑用户</span>
            </template>
            <a-button
              type="default"
              shape="circle"
              icon="edit"
              @click="()=>{updateUserModel = record;userCUModalVisible = true}"
            ></a-button>
          </a-tooltip>
          <a-popconfirm
            class="act-btn"
            title="是否重置该用户密码"
            @confirm="passwordReset(record)"
            okText="确定"
            cancelText="取消"
          >
            <a-tooltip placement="top">
              <template slot="title">
                <span>重置密码</span>
              </template>
              <a-button type="default" shape="circle" icon="lock"></a-button>
            </a-tooltip>
          </a-popconfirm>
          <a-tooltip placement="top">
            <template slot="title">
              <span>分配角色</span>
            </template>
            <a-button type="default" shape="circle" icon="link" @click="showModalSignRole(record)"></a-button>
          </a-tooltip>
          <a-popconfirm
            title="是否删除该条记录"
            @confirm="deleteInformation(record)"
            okText="确定"
            cancelText="取消"
          >
            <a-tooltip placement="top">
              <template slot="title">
                <span>删除用户</span>
              </template>
              <a-button style="margin-left:8px;" type="danger" shape="circle" icon="delete"></a-button>
            </a-tooltip>
          </a-popconfirm>
        </div>
      </template>
    </j-table>

    <!-- 分配角色Modal -->
    <a-modal
      :maskClosable="false"
      width="50%"
      loading="signRoleLoading"
      :title="signRoleModalTitel"
      v-model="signRoleVisible"
      @ok="signRole"
    >
      <a-tree
        showLine
        checkable
        :defaultExpandAll="true"
        :checkedKeys="roleCheckKeys"
        @check="onRoleCheck"
        :treeData="roleTreeData"
      ></a-tree>
    </a-modal>

    <UserCUModal
      v-if="userCUModalVisible"
      v-on:close="(refresh)=>{userCUModalVisible = false;if(refresh){fetch();}}"
      :orgId="drivasstId"
      :updateUserModel="updateUserModel"
      :systemId="systemId"
    />
    </a-drawer>

  </div>
</template>

<script>
import mixins from "../mixins";
import JTable from "./JTable";
import UserCUModal from "./UserCUModal";

export default {
  name: "UserManage",
  props: ["orgId","systemId"],
  components: {
    JTable,
    UserCUModal,
  },
  data() {
    return {
      visible: false,
      drawerWidth:document.body.clientWidth / 3 * 2,
      data: [],
      loading: false,
      orderby: "user_id desc",
      userCode: "",
      userName: "",
      pagination: {
        pageSize: 20,
        pageSizeOptions: ["20", "30", "50"],
        current: 1,
        total: 0
      },
      dic10003: {},
      dic10004: {},
      userCUModalVisible: false,
      updateUserModel: null,
      signRoleLoading: false,
      signRoleVisible: false,
      roleTreeData: [],
      roleCheckKeys: [],

      columns: [
        {
          title: "用户账号",
          dataIndex: "user_code",
          key: "user_code",
          fixed: "left",
          align: "center",
          sorter: true
        },
        {
          title: "用户姓名",
          dataIndex: "user_name",
          key: "user_name",
          fixed: "left",
          align: "center",
          sorter: true
        },
        {
          title: "用户手机号",
          dataIndex: "mobile_no",
          key: "mobile_no",
          align: "center"
        },
        {
          title: "用户邮箱",
          dataIndex: "mailbox_no",
          key: "mailbox_no",
          align: "center"
        },
        {
          title: "用户状态",
          dataIndex: "user_statusdesc",
          key: "user_statusdesc",
          align: "center"
        },
        {
          title: "用户性别",
          dataIndex: "user_sexdesc",
          key: "user_sexdesc",
          align: "center"
        },
        {
          title: "操作",
          key: "operation",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "operation" }
        }
      ],
      tableSize: {},
        drivasstId:'',
    };
  },
  mixins: [mixins],
  created() {
    this.visible = true;

    const that = this;
    this.fetchDataDic(
      ["10003", "10004"],
      data => {
        that.dic10003 = data.dictlist[0]["10003"];
        that.dic10004 = data.dictlist[1]["10004"];
        that.fetch();
      },
      that
    );
  },
  computed: {
    signRoleModalTitel() {
      return this.editRow && this.editRow["user_name"]
        ? "给用户[" + this.editRow["user_name"] + "] - 分配角色"
        : "分配角色";
    }
  },
  methods: {
    onClose() {
      this.visible = false;
      this.$emit("close");
    },
    fetch() {
      const that = this;
      that.data = [];
      that.loading = true;
      const reqData = {
        currpage: that.pagination.current + "",
        recnumperpage: that.pagination.pageSize + "",
        orderby: that.orderby,
        org_id:that.orgId,
      };
      if (that.userCode) {
        reqData["user_code"] = that.userCode;
      }
      if (that.userName) {
        reqData["user_name"] = that.userName;
      }
      this.$http.post(
        this.$marco.api.userPagingList,
        reqData,
        data => {
          // that.$log.success(JSON.stringify(data));
          that.loading = false;
          that.data = that.data.concat(data["pagelist"]);
          for (let i = 0; i < that.data.length; i++) {
            that.data[i]["user_type_desc"] =
              that.dic10004[that.data[i]["user_type"]];
          }
          that.pagination["total"] = data.recnum;
        },
        errorDesc => {
          that.loading = false;
          that.$log.normal(JSON.stringify(errorDesc));
        },
        error => {
          that.loading = false;
          that.$log.error(JSON.stringify(error));
        },
        that
      );
    },
    deleteInformation(row) {
      const that = this;
      this.$http.post(
        this.$marco.api.userDelete,
        row,
        data => {
          this.fetch();
          this.$message.success("删除成功！");
        },
        errorDesc => {
          that.$log.normal(JSON.stringify(errorDesc));
          that.$message.error(errorDesc);
        },
        error => {
          that.$log.error(JSON.stringify(error));
          that.$message.error(error);
        }
      );
    },
    passwordReset(row) {
      const that = this;
      this.$http.post(
        this.$marco.api.passwordReset,
        row,
        data => {
          this.$message.success("重置成功！");
        },
        errorDesc => {
          that.$log.normal(JSON.stringify(errorDesc));
          that.$message.error(errorDesc);
        },
        error => {
          that.$log.error(JSON.stringify(error));
          that.$message.error(error);
        }
      );
    },
    showModalSignRole(row) {
      this.signRoleVisible = true;
      this.editRow = row;
      this.fetchRoleByUser();
    },
    fetchRoleByUser() {
      const that = this;
      that.signRoleLoading = true;
      this.$http.post(
        this.$marco.api.getDepartRoleTreeForSign,
        {
          user_id: that.editRow["user_id"],
          org_id:that.orgId,
        },
        data => {
          that.signRoleLoading = false;
          // that.$log.success(JSON.stringify(data));

          const departroletree = data["departroletree"];
          this.formatRoleHttpData(departroletree);
          that.roleTreeData = departroletree;
          that.roleCheckKeys = data["checkeddepartroles"];
        },
        errorDesc => {
          that.signRoleLoading = false;
          that.$log.normal(JSON.stringify(errorDesc));
        },
        error => {
          that.signRoleLoading = false;
          that.$log.error(JSON.stringify(error));
        }
      );
    },
    formatRoleHttpData(tree) {
      for (let i = 0; i < tree.length; i++) {
        tree[i]["key"] = tree[i]["departrole_id"];
        tree[i]["title"] = tree[i]["departrole_name"];
        tree[i]["parentId"] = tree[i]["departrole_parentid"];
        if (tree[i]["subDepartroles"]) {
          tree[i]["children"] = tree[i]["subDepartroles"];
          this.formatRoleHttpData(tree[i]["children"]);
        }
      }
    },
    onRoleCheck(checkedKeys) {
      this.roleCheckKeys = checkedKeys;
    },
    signRole() {
      const that = this;
      that.signRoleLoading = true;
      this.$http.post(
        this.$marco.api.signDeapartRole,
        {
          checkeddepartroles: that.roleCheckKeys,
          user_id: that.editRow["user_id"]
        },
        data => {
          that.signRoleLoading = false;
          that.signRoleVisible = false;
          // that.$log.success(JSON.stringify(data));
          this.$message.success("操作成功");
        },
        errorDesc => {
          that.signRoleLoading = false;
          that.signRoleVisible = false;
          that.$log.normal(JSON.stringify(errorDesc));
          this.$message.success(errorDesc);
        },
        error => {
          that.signRoleLoading = false;
          that.signRoleVisible = false;
          that.$log.error(JSON.stringify(error));
          this.$message.error("操作失败");
        }
      );
    },
    
  }
};
</script>
<style scope="scoped">
.ant-pagination {
  margin: 24px auto;
}
.act-btn {
  margin: 0 8px;
}
.ant-btn-circle {
  width: 25px;
  height: 25px;
}
.ant-btn-circle i {
  font-size: 12px;
}
</style>
